import React from 'react'
import LocalizedTextField from 'ui-shared/LocalizedFields/LocalizedTextField'
import MainProductList, {
  MainProductListProps,
} from 'ui-shared/WrappedInputs/MainProductList'

const ProfessionalFiguresList: React.FC<MainProductListProps> = (props) => {
  return (
    <MainProductList {...props}>
      <LocalizedTextField source="sectionName" label="Type" sortable={false} />
    </MainProductList>
  )
}

export default ProfessionalFiguresList
